// extracted by mini-css-extract-plugin
export default {"likesBar":"Likes_likesBar__uzqSZ","like":"Likes_like__h5-XF","dislike":"Likes_dislike__dnKB6","amountOfLikes":"Likes_amountOfLikes__CM14d"};